import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "store/store";
import { getSourceList } from "services";
import {
  setCountChecked,
  setSourceProject,
} from "store/slicer/GestioneDetailProjectSlice";
import { InputSearchSourceProject } from "./InputSearchSourceProject";
import { currentlyUsed, labelFonte, labelFonti } from "_constants";
import { ButtonChoiceAddProject } from "components/buttons";
import { CheckboxSourcesList } from "./CheckboxSourcesList";
import { Tooltip } from "primereact/tooltip";

export const SourceList = ({ projectId }: { projectId: string }) => {
  const dispatch = useAppDispatch();
  const sourceCount = useAppSelector(
    (state) => state.gestioneDetailProjectSlice.count
  );
  const loaded = useAppSelector(
    (state) => state.gestioneDetailProjectSlice.loaded
  );

  useEffect(() => {
    if (projectId && !loaded) {
      getSourceList(projectId)
        .then((res) => {
          dispatch(setSourceProject(res.data));
          let count = 0;
          count =
            (res.data.codesList?.filter((item: any) => item.isChecked)
              ?.length ?? 0) +
            (res.data.privateSourcesList?.filter((item: any) => item.isChecked)
              ?.length ?? 0) +
            (res.data.sourcesList?.filter((item: any) => item.isChecked)
              ?.length ?? 0);
          dispatch(setCountChecked(count));
        })
        .catch((_) => { });
    }
  }, [dispatch, projectId, loaded]);

  return (
    <div className="container-source relative">
      <div className="header-list">
        <Tooltip target=".fonti-info">
          Cambiando le fonti durante una chat, la cronologia verrà resettata.
          <br /><br />
          Le vecchie risposte mostreranno <i className="pi p-button-icon pi-lock" style={{ fontSize: '15px' }}></i>.
        </Tooltip>

        <h4 className="blue-text">{labelFonti} <i className="pi pi-info-circle text-sm cursor-pointer text-primary fonti-info" style={{ fontSize: '15px' }} /></h4>
        <span className="text-base-regular">
          {`${sourceCount} ${(sourceCount === 1
            ? labelFonte
            : labelFonti
          ).toLowerCase()} ${currentlyUsed}`}
        </span>
      </div>
      <div className="flex-container">
        <InputSearchSourceProject />
        <ButtonChoiceAddProject projectId={projectId} />
      </div>
      <CheckboxSourcesList projectId={projectId} />
    </div>
  );
};
